import { ImpersonateAssistDetailModel } from '../shared/models/impersonate-assist-detail.model';
import { ImpersonateUserModel } from '../shared/models/impersonate-user.model';
import { LobbyGridModel } from '../shared/models/lobby-grid.model';
import { LobbyStaffStatusGridData } from '../shared/models/lobby-staff-status-grid-data.model';

export interface LobbyStaffStatusState {
    lobbyStaffGridData: LobbyStaffStatusGridData | null,
    lobbyGridData: LobbyGridModel | null,
    impersonateUserDetails: ImpersonateUserModel[] | null,
    impersonateAssistDetails: ImpersonateAssistDetailModel | null,
    PromptImpersonatePopup: boolean
}

export const initialState: LobbyStaffStatusState = {
    lobbyStaffGridData: null,
    lobbyGridData: null,
    impersonateUserDetails: null,
    PromptImpersonatePopup: false,
    impersonateAssistDetails: null
}